import React from 'react';
import ReactDOM from 'react-dom';

import Types from './common/Types.jsx';

if (typeof(global) === 'undefined') {
    global = window;
}
global.React = React;
global.ReactDOM = ReactDOM;
global.Components = Types.Block.getAllComponents();